'use strict';

(function () {
    let currScrollY

    let prevScrollY

    let scheduledAnimationFrame

    const header = document.getElementById('header')

    const secondaryMenu = document.getElementById('secondary_menu_wrapper')

    const stickyClassName = 'sticky'

    const stickyHideClassName = `${stickyClassName}--hide`

    const offscreenClassName = 'offscreen'

    const onUpdate = () => {
        const isUp = currScrollY < (prevScrollY || window.scrollY)

        const isSticky = (el) => el
            && el.classList.contains(stickyClassName)

        const isStickyHide = (el) => el
            && el.classList.contains(stickyHideClassName)

        const isOffscreen = (el) => el
            && el.classList.contains(offscreenClassName)

        const setState = (el) => {
            if (!el)
                return

            const { bottom, top } = el.getBoundingClientRect()

            const pageOffsetTop
                = ((document.getElementById('page') || {}).offsetTop || 0)

            const offsetTop = pageOffsetTop
                + (el === secondaryMenu
                    ? header.clientHeight
                    : 0)

            if (isUp
                    && !isOffscreen(el)
                    && isSticky(el)
                    && top >= offsetTop)
                el.classList.remove(stickyClassName)

            if (isUp
                    && currScrollY
                    && isOffscreen(el)) {
                if (!isSticky(el))
                    el.classList.add(stickyClassName)

                if (isStickyHide(el))
                    el.classList.remove(stickyHideClassName)
            }

            if (!isUp
                    && currScrollY
                    && isOffscreen(el)
                    && isSticky(el)
                    && !isStickyHide(el))
                el.classList.add(stickyHideClassName)

            if (bottom < pageOffsetTop
                    && !isOffscreen(el))
                el.classList.add(offscreenClassName)

            if (bottom >= pageOffsetTop
                    && isOffscreen(el))
                el.classList.remove(offscreenClassName)

            if (!currScrollY
                    && isSticky(el))
                el.classList.remove(stickyClassName)
        }

        setState(header)

        setState(secondaryMenu)

        scheduledAnimationFrame = false
    }

    const onScroll = (e) => {
        prevScrollY = currScrollY

        currScrollY = window.scrollY

        if (!prevScrollY
                || prevScrollY === currScrollY
                || scheduledAnimationFrame
                || document.body.classList.contains('menu--open')
                || document.documentElement.getAttribute('data-resizing')
                    === 'true')
            return

        scheduledAnimationFrame = true

        window.requestAnimationFrame(onUpdate)
    }

    window.addEventListener('load', () => {
        onScroll()

        window.addEventListener('resize', onScroll)

        window.addEventListener('scroll', onScroll, { passive: true })
    })
})()
